import { getModuleLoginPath, resolveModuleLoginPathFromRoute } from '@/config/moduleEntries';
import { MASTER_SIGN_IN_PATH, MODULE_HUB_PATH } from '@/constants/authRoutes';
import { readStoredEntryModule, readStoredWorkspaceModule } from '@/utils/moduleScope';

export type ModuleSignInPathOptions = {
  pathname?: string;
  entryModule?: string | null;
  activeModule?: string | null;
  masterAdmin?: boolean;
};

/**
 * Resolve the product sign-in URL after logout or session expiry.
 * Current route wins (e.g. /hr/employees → /hr/login) so owners switching apps
 * are not sent to a stale workspace module login.
 */
export function resolveModuleSignInPath(options: ModuleSignInPathOptions = {}): string {
  const pathname =
    options.pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');

  if (options.masterAdmin || pathname.startsWith('/master')) {
    return MASTER_SIGN_IN_PATH;
  }

  const fromRoute = resolveModuleLoginPathFromRoute(pathname);
  if (fromRoute) {
    return fromRoute;
  }

  const module = options.entryModule ?? options.activeModule;
  if (module) {
    return getModuleLoginPath(module);
  }

  const stored = readStoredEntryModule() ?? readStoredWorkspaceModule();
  if (stored) {
    return getModuleLoginPath(stored);
  }

  return MODULE_HUB_PATH;
}
